._VideoContent_mqlwe_1 {
  position: relative;
}
._VideoContent_mqlwe_1 ._video_mqlwe_4 {
  width: 100%;
  height: 100%;
}